localizeCount = require 'app/scripts/lib/localize-count'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_header')

module.exports = t.renderable ({ canRename, orgLogoUrl, orgLogoUrl2x, hasBusinessClass, isBusinessClass,
  isEnterprise, orgDisplayName, name, orgName, isLoggedIn, isAdmin, isMember, isPrivateTeam, isUntitled,
  canJoin, canInviteMembers, selfJoin, canAssign, showCopyButton, boardCardCount,
  isPrivateTeamForEnterpriseVisibleBoard, templateModeEnabled, starTooltipKey }) ->

  boardType = (if isBusinessClass then 'BC' else if isEnterprise then 'ENT' else 'Free')

  classes =
    'board-header-btn': true
    'mod-board-name': true
    'inline-rename-board': true
    'js-rename-board': canRename
    'no-edit': !canRename
    'should-rename': isUntitled && canRename

  displayNameClasses =
    'board-header-btn': true
    'board-header-btn-org-name': true
    'js-open-org-menu': true
    'board-header-btn-without-icon': !orgLogoUrl

  t.div { href: '#', class: t.classify(classes) }, ->
    t.span '.js-board-editing-target.board-header-btn-text', { dir: 'auto' }, ->
      t.text name

    t.input '.board-name-input.js-board-name-input', {
      'aria-label': name
      spellcheck: 'false'
      dir: 'auto'
      maxLength: 512
      value: name
    }

  if templateModeEnabled
    t.div '.board-header-btn-template-badge.js-board-template-badge'

  if isLoggedIn
    t.a '.board-header-btn.js-star-board', { href: '#', title: t.l(starTooltipKey), 'aria-label': t.l('star-or-unstar-board') }, ->
      t.icon 'star', { class: 'board-header-btn-icon' }

  t.div '.js-board-header-btn-org-wrapper.board-header-btn-org-wrapper', ->
    if orgDisplayName
      t.span '.board-header-btn-divider'
      t.a { href: '/' + orgName, class: t.classify(displayNameClasses), data: { boardtype: boardType } }, ->
        if orgLogoUrl
          t.div '.board-header-btn-name-org-logo-container', ->
            t.img
              class: 'board-header-btn-name-org-logo'
              src: orgLogoUrl
              srcSet: "#{orgLogoUrl} 1x, #{orgLogoUrl2x} 2x"
        t.span '.board-header-btn-text', ->
          t.text orgDisplayName
          t.span '.org-label', ->
            t.text boardType
      t.span '.board-header-btn-divider'

    t.div '.board-header-btns.mod-left', ->
      if !orgDisplayName && !templateModeEnabled
        t.span '.board-header-btn-divider'
        if (isMember && isPrivateTeam) || isPrivateTeamForEnterpriseVisibleBoard
          t.span '.board-header-btn.board-header-btn-without-icon.board-header-btn-text.no-edit', ->
            t.format 'private-team'
          t.span '.board-header-btn-divider'
        else if !isPrivateTeam && !templateModeEnabled
          t.a '.board-header-btn.board-header-btn-without-icon.js-add-board-to-team', { href: '#', class: t.classify('no-edit': !isAdmin) }, ->
            t.span '.board-header-btn-text', ->
              t.format 'personal'
          t.span '.board-header-btn-divider'

    t.a '.board-header-btn.perms-btn.js-change-vis', { href: '#', id: 'permission-level' }

  t.span '.board-header-btn-divider'

  t.div '.board-header-btns.mod-left', ->
    t.div '.board-header-facepile.js-fill-facepile', { class: t.classify('js-list-draggable-board-members': canAssign) }

    t.a '#member-count.board-header-btn.board-header-btn-member-count.js-open-show-all-board-members.js-fill-board-member-count', { href: '#' }, ->
    t.span '#member-count-notifications'

    if canInviteMembers
      t.a '.board-header-btn.board-header-btn-invite.board-header-btn-without-icon.js-open-manage-board-members', { href: '#', title: t.l('invite-to-board') }, ->
        t.span '.board-header-btn-text', ->
          t.format 'invite'

    if canJoin && !templateModeEnabled
      t.a '.board-header-btn.board-header-btn-without-icon.board-header-btn-join-board.js-join-board', { href: '#', title: t.l('org-members-can-join-this-board') }, -> # hovertext to replace helper
        t.span '.board-header-btn-text', ->
          t.format 'join-board'

  t.div '.board-header-btns.mod-right', ->

    t.a '.board-header-btn.mod-filter-indicator.hide.js-filter-cards-indicator.board-header-btn-without-icon', { href: '#' }, ->
      t.span '.board-header-btn-text', -> t.text localizeCount('search-results', boardCardCount)
      t.icon 'close', { class: 'board-header-btn-icon-close js-filter-card-clear' }

    t.a '.board-header-btn.sub-btn.hide.js-board-header-subscribed', { href: '#' }, ->
      t.icon 'subscribe', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text', ->
        t.format 'watch'

    t.a '.board-header-btn.calendar-btn.hide.js-calendar', { href: '#' }, ->
      t.icon 'calendar', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text', ->
        t.format 'calendar'

    t.a '.board-header-btn.hide.js-map-btn', { href: '#' }, ->
      t.span '.icon-sm.icon-location.board-header-btn-icon'
      t.span '.board-header-btn-text', ->
        t.format 'map'

    t.span '.js-plugin-header-btns'

    if isLoggedIn && showCopyButton && !templateModeEnabled
      t.a '.board-header-btn.js-copy-board', { href: '#' }, ->
        t.icon 'board', { class: 'board-header-btn-icon' }
        t.span '.board-header-btn-text', ->
          t.format 'copy-board'

    t.a '.board-header-btn.mod-show-menu.js-show-sidebar', { href: '#' }, ->
      t.icon 'overflow-menu-horizontal', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text', ->
        t.format 'show-menu'

  t.span '#board-header-notification'
